<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { CapexAccountReadModel } from "@Quest/Financials/Capex/Domain/readmodels";
    import { CapexItemEditorFormSubmitEventPayload, CapexItemEditorViewModel } from "@Quest/Financials/Capex/Components/CapexItemEditor";


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CapexItemEditor extends Vue
    {
        get vm(): CapexItemEditorViewModel { return this.$props.viewModel as CapexItemEditorViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }        
        get modalTitle(): string { return this.vm.modalTitle; }
        get confirmButtonLabel(): string { return this.vm.confirmButtonLabel; }

        get currencyLabel(): boolean { return this.vm.currencyLabel; }
        get accounts(): CapexAccountReadModel[] { return this.vm.accounts; }

        get name(): string { return this.vm.name; }
        set name(val: string) { this.vm.name = val; }

        get accountId(): string | null { return this.vm.accountId; }
        set accountId(val: string | null) { this.vm.accountId = val; }

        get cost(): number | null { return this.vm.cost; }
        set cost(val: number | null) { this.vm.cost = val; }

        get usefulLifeInYears(): number | null { return this.vm.usefulLifeInYears; }
        set usefulLifeInYears(val: number | null) { this.vm.usefulLifeInYears = val; }

        get acquisitionMonthIndex(): number | null { return this.vm.acquisitionMonthIndex; }
        set acquisitionMonthIndex(val: number | null) { this.vm.acquisitionMonthIndex = val; }

        get salvageValue(): number | null { return this.vm.salvageValue; }
        set salvageValue(val: number | null) { this.vm.salvageValue = val; }

        handleFormSubmit()
        {
            const payload = new CapexItemEditorFormSubmitEventPayload(this.vm.id, this.name, this.accountId, this.cost, this.usefulLifeInYears, this.acquisitionMonthIndex, this.salvageValue);
            this.$emit('form-submit', payload);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="capex-item-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required minlength="2" maxlength="100" />
                            </div>
                            <div class="form-group">
                                <label for="account">Account:</label>
                                <select id="account" v-model="accountId" class="form-control" required>
                                    <option :value="null">Select capex account</option>
                                    <option v-for="a in accounts" :value="a.Id">{{a.Name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Cost ({{currencyLabel}}):</label>
                                <input type="number" v-model.number="cost" class="form-control" required min="0" step="any" />
                            </div>
                            <div class="form-group">
                                <label>Useful life (in years):</label>
                                <input type="number" v-model.number="usefulLifeInYears" class="form-control" required min="1" step="1" />
                            </div>
                            <div class="form-group">
                                <label>Capex Acquisition Month (0 = Project Start):</label>
                                <input type="number" v-model.number="acquisitionMonthIndex" class="form-control" required min="0" step="1" />
                            </div>
                            <div class="form-group">
                                <label>Salvage value ({{currencyLabel}}):</label>
                                <input type="number" v-model.number="salvageValue" class="form-control" />
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="capex-item-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>